import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, FlatButton, TextField } from 'material-ui'
import styles from './styles/ExpandedMediaModal.css'

const TextUnknownDialog = ({
  closeDialog,
  onChangePhone,
  onSubmit,
  open,
  phone,
}) => (
  <Dialog
    open={open}
    onRequestClose={closeDialog}
    contentStyle={{ width: '500px' }}
    zDepth={10}
  >
    <div className={styles.popOverContainer}>
      <h2>Please type a phone number:</h2>
      <TextField
        id="phone"
        floatingLabelText="Phone Number"
        floatingLabelFixed
        onChange={e => onChangePhone(e)}
        value={phone}
        style={{ width: '350px' }}
      />
      <div className={styles.popOverButton}>
        <FlatButton
          label="Submit"
          disabled={!phone.length}
          primary
          onClick={onSubmit}
        />
        <FlatButton
          label="Cancel"
          secondary
          onClick={closeDialog}
        />
      </div>
    </div>
  </Dialog>
)

TextUnknownDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  onChangePhone: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  phone: PropTypes.string.isRequired,
}

export default TextUnknownDialog



// WEBPACK FOOTER //
// ./src/components/Messages/TextUnknownDialog.js